import React, { useEffect, useState } from "react";
import { Button, Card } from "flowbite-react";
import clsx from "clsx";
import { ProductSelect, AdvantageCheckIcon, Add } from "../../common/icons";
import { getAltItemDescription } from "../../common/utils";

import ProductPricePoints from "./product-price-points";
import { travellerBenefits } from "../../assets/benefits/benefits";
import Helper from "../../common/helper";

import {
  AdvantagesList,
  getPWPComponent,
  returnAdvantageHeader,
} from "./multi-card";

const isCampaign1363 = Helper.isVNCampaign();


const ProductButtonMobile = ({
  isSelected,
  itemName,
  className,
  color,
  ...restProps
}) => (
  <>
    <Button
      color={color}
      className={clsx(
        `holder-title group border border-[#D1D5DB] rounded-md py-4 px-2 hover:bg-gradient-to-br hover:from-[#18A09F] hover:to-[#050033] ${className}`,
        {
          "holder-title-gradient": isSelected,
        }
      )}
      {...restProps}
    >
      <div className="flex justify-center items-center flex-col gap-3">
        <h5
          className={clsx(
            `text-sm text-[#050033] dark:text-[#FFFFFF] font-montserrat font-semibold uppercase text-center group-hover:text-[#FFF]`,
            {
              "text-[#FFFFFF]": isSelected,
            }
          )}
        >
          {itemName}
        </h5>
        {isSelected && <ProductSelect />}
      </div>
    </Button>
  </>
);

export const getAllExplorerContent = (languages, benefitsTranslations) => {
    const itemName = 'ALL Accor+ Explorer'
      let AllExplorerPlusBenefits =
        benefitsTranslations.benefits[4]["all explorer"];
    return (
      <React.Fragment>       
      {getTitle(itemName, languages.newDate)}
      <ul className="membership-inclusions membership-allproduct">
        {
        AllExplorerPlusBenefits.map(
          (
            advantage,
            id // non-qbr
          ) => (
            <li
              key={id}
              className={clsx({
                "mt-1": id === 0,
                "mt-1": id !== 0
              })}
            >
              <AdvantagesList
                advantageText={
                  advantage[benefitsTranslations.region]
                }
              />
            </li>
          )
        )}
      </ul>
    </React.Fragment>
  );
};

export const getBusinessExplorerContent = (languages, benefitsTranslations) => {
  console.log('benefitsTranslations', benefitsTranslations)
    const itemName = 'Accor Plus Explorer'
      let QantasBusinessRewards = [
        {au: '10,000 Qantas Points PLUS 3,000 ALL Reward Points'},
        {au: '1 complimentary night in Asia Pacific'},
        {au: 'Up to 50% off Red Hot Rooms in Asia Pacific'},
        {au: 'Up to 50% off on dining in Asia Pacific'},
        {au: '15% discount on drinks in Asia'},
        {au: '10% off hotel stays in Asia Pacific'},
        {au: '20 ALL Accor Status Nights'},
        {au: 'Exclusive events and offers'},
      ]
    return (
      <React.Fragment>       
      {getTitle(itemName, languages.currentDate)}
      <ul className="membership-inclusions membership-allproduct">
        {
        QantasBusinessRewards.map(
          (
            advantage,
            id // non-qbr
          ) => (
            <li
              key={id}
              className={clsx({
                "mt-1": id === 0,
                "mt-1": id !== 0
              })}
            >
              <AdvantagesList
                advantageText={
                  advantage['au']
                }
                id={id}
              />
            </li>
          )
        )}
      </ul>
    </React.Fragment>
    );
};


export const getTitle = (itemName, content) => {
  return (
    <React.Fragment>
      <div className="mt-4 mb-2">
        <p className="font-semibold">
          <span className='text-capitalize'>{itemName}</span>
          <span> benefits</span>
        </p>
      </div>

      <div className="mb-4">
        <p className="text-uppercase text-base benefits-text">{content || "Now until 30 Sep, 2025"}</p>
      </div>
    </React.Fragment>
  )
}

export default function ProductSelectMobile({
  benefitsTranslations,
  products,
  selectMembership,
  couponObj,
  isUserLogged,
  locationDataCurrency,
  languages,
  locationData,
  businessCategories,
  className,
  refundWidgetToggle
}) {
  const [selectedItem, setSelectedItem] = useState({});

  //start of LD on or off for refunds
  // const LDProduct = true;
  const { item_group_id, business_category_id } = products[0] || {};
  const queryUrlLocation = new URLSearchParams(window.location?.search);
  const autoSelectProduct = queryUrlLocation.get("product");
  const {
    item_group_id: selectedItemGroupId,
    purchase_price,
    tax_amt,
    currency_text,
    item_group_name,
    priceLevel,
    item_group_components,
    component_items,
    isQbr,
  } = selectedItem || {};

  const itemGroupId = selectedItemGroupId;
  const altItemDescription = getAltItemDescription(businessCategories, business_category_id, item_group_id)
  const currentItemName = altItemDescription || item_group_name?.replace(/MEMBERSHIP/gi, "");
  const totalAmt = Number(purchase_price) + Number(tax_amt);
  const currency = currency_text || locationDataCurrency;
  const componentItems = component_items || item_group_components;
  const foc = Helper.focLength(componentItems);
  const getCoupon = Helper.checkCoupon(selectedItem, couponObj);
  const ExplorerMembership = item_group_name?.includes("EXPLORER")
  const ExplorerPlusMembership = itemGroupId === "4293";
  const travellerMembership = item_group_name
    ?.toLowerCase()
    ?.includes("traveller");
  const DiscoveryMembership = item_group_name
    ?.toLowerCase()
    ?.includes("discovery");
  const getVoucherDetails = Helper.voucherBenefitsChecker(locationData.country);
  const isBasePrice = priceLevel?.includes("BASE PRICE");
  const PWP = Helper.newpwpCheck(
    selectedItem,
    isUserLogged,
    locationData,
    businessCategories
  );
  const isAMEX = Helper.isAMEX();
  const isSCB = Helper.isSCB();
  const popularChoice = languages.mostPopularChoice
    ? languages.mostPopularChoice
    : "Most popular choice";

  let TravellerBenefits = benefitsTranslations.benefits[0].traveller;
  let ExplorerBenefits = benefitsTranslations.benefits[1].explorer;
  let ExplorerPlusBenefits = benefitsTranslations.benefits[2]["explorer plus"];
  let DiscoveryBenefits = benefitsTranslations.benefits[3].discovery;
  useEffect(() => {
    if (autoSelectProduct) {
      let filterAutoSelectProduct;
      if (autoSelectProduct === "qantas") {
        filterAutoSelectProduct = products?.filter(
          (membership) => membership?.qbrPoints
        );
      } else {
        filterAutoSelectProduct = products?.filter((membership) =>
          membership.item_group_name?.toLowerCase().includes(autoSelectProduct)
        );
      }
      const selectProduct = filterAutoSelectProduct[0];

      if (selectProduct) {
        selectMembership(selectProduct);
        setSelectedItem(selectProduct);
      }
    } else {
      setSelectedItem(products[0]);
      selectMembership(products[0]);
    }
  }, []);

  function capitalizeFirstLetter(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }


  const isMobile = true;


  return (
    <div className={`min-w-[343px] max-w-full ${className}`}>
      <Button.Group className="flex justify-start gap-2 overflow-x-auto">
        {products?.map((item, idx) => {
          const productSelect = () => {
            selectMembership(item);
            setSelectedItem(item);
          };
          const {item_group_description, item_group_id, business_category_id} = item || {};
          const itemGroupName = item_group_description;
          const altItemDescription = getAltItemDescription(businessCategories, business_category_id, item_group_id);
          const itemName = altItemDescription || itemGroupName
            ?.replace(/ACCOR PLUS | MEMBERSHIP/gi, "")
            .trim();
          return (
            <ProductButtonMobile
              className={`${products?.length > 3 ? "min-w-[99px]" : "min-w-[109px]"
                } w-full`}
              key={item.item_group_id + idx}
              itemName={itemName}
              isSelected={item.isSelected}
              onClick={() => productSelect()}
            />
          );
        })}
      </Button.Group>

      {Object.keys(selectedItem).length ? (
        <div className="flex flex-col items-center">
          <div className=" w-full">
            <div className="item-info py-4 px-2">
              <p className="text-base tracking-tight text-[#050033] dark:text-[#FFFFFF] font-montserrat font-semibold text-center">
                {/* Best for regular traveller */}
                {selectedItem.item_group_name === "EXPLORER MEMBERSHIP" &&
                  !isQbr
                  ? popularChoice
                  : ""}
              </p>
            </div>
            <ProductPricePoints
              currency={currency}
              totalAmt={totalAmt}
              isUserLogged={isUserLogged}
              isQbr={isQbr}
              languages={languages}
              PWP={PWP}
              getCoupon={getCoupon}
              item={selectedItem}
              locationData={locationData}
              getPWPComponent={getPWPComponent}
            />
            {/* <div className="py-3">
              <p className="font-montserrat font-bold">
                {languages.enjoyBenefits
                  ? languages.enjoyBenefits
                  : "ENJOY ACCOR PLUS UNIVERSAL BENEFITS"}
              </p>
            </div> */}
            <div className="flex h-full flex-col justify-center gap-2">
              {/* <h5 className="font-semibold mt-5">
                {returnAdvantageHeader(currentItemName, languages, isMobile)}
              </h5> */}
              {/* Added for CVP */}
              {refundWidgetToggle && ExplorerMembership && !isQbr && getTitle(capitalizeFirstLetter(currentItemName), languages.currentDate)}
              <ul className="membership-inclusions">
                {/* benefitsTranslations */}
                {/* {foc !== 0 && isQbr && languages.qbrFreeHotel && (
                  <div className="">
                    <p className="font-montserrat align-middle">
                      <Add />{" "}
                      {languages.qbrFreeHotel
                        ? languages.qbrFreeHotel
                        : "Free Hotel Night"}
                    </p>
                  </div>
                )} */}
                {travellerMembership &&
                  TravellerBenefits.map((advantage, id) => (
                    <li
                      key={id}
                      className={clsx({
                        "": id === 0,
                        "mt-1": id !== 0
                      })}
                    >
                      <AdvantagesList
                        advantageText={advantage[benefitsTranslations.region]}
                      />
                    </li>
                  ))}

                {DiscoveryMembership &&
                  DiscoveryBenefits.map((advantage, id) => (
                    <li
                      key={id}
                      className={clsx({
                        "": id === 0,
                      })}
                    >
                      <AdvantagesList
                        advantageText={advantage[benefitsTranslations.region]}
                      />
                    </li>
                  ))}
                {foc !== 0 &&
                  !isQbr &&
                  refundWidgetToggle &&
                  ExplorerMembership && !isSCB &&
                  ExplorerBenefits?.map(
                    (
                      advantage,
                      id // non-qbr
                    ) => (
                      <li
                        key={id}
                        className={clsx({
                          "": id === 0,
                          "mt-1": id !== 0
                        })}
                      >
                        <AdvantagesList
                          advantageText={advantage[benefitsTranslations.region]}
                        />
                      </li>
                    )
                  )}
                {foc !== 0 &&
                  !isQbr &&
                  ExplorerPlusMembership &&
                  ExplorerPlusBenefits.map(
                    (
                      advantage,
                      id // non-qbr
                    ) => (
                      <li
                        key={id}
                        className={clsx({
                          "": id === 0,
                          "mt-1": id !== 0
                        })}
                      >
                        <AdvantagesList
                          advantageText={advantage[benefitsTranslations.region]}
                        />
                      </li>
                    )
                  )}
                {/* foc !== 0 && ExplorerMembership && isQbr && (
                  <li className="inclusion-list flex items-center">
                    <div className="list-icon-holder">
                      <AdvantageCheckIcon />
                    </div>
                    <span className="list-desc text-lg">
                      {foc > 1
                        ? foc + languages.productFocAvailableMultipleMessage
                          ? languages.productFocAvailableMultipleMessage
                          : " Stay Plus complimentary nights"
                        : foc + languages.productFocAvailableSingleMessage
                        ? languages.productFocAvailableSingleMessage
                        : " Complimentary night stay at participating hotels "}
                    </span>
                  </li>
                )} */}

                {ExplorerMembership &&
                  isBasePrice &&
                  !ExplorerPlusMembership &&
                  !isQbr &&
                  languages.productBonusRewardPoints ? (
                  <li className="inclusion-list flex items-center">
                    <div className="list-icon-holder">
                      <AdvantageCheckIcon />
                    </div>
                    <span className="list-desc text-lg">
                      {languages.productBonusRewardPoints
                        ? languages.productBonusRewardPoints
                        : "Bonus 2,000 Reward Points (For a limited time)"}
                    </span>
                  </li>
                ) : (
                  <></>
                )}
                {DiscoveryMembership &&
                  getVoucherDetails[1].discovery &&
                  !isAMEX && (
                    <li>
                      <AdvantagesList
                        advantageText={
                          languages?.productVoucherBenefitsDiscovery ||
                          " Exclusive dining and accommodation discount vouchers"
                        }
                      />
                    </li>
                  )}
                {ExplorerMembership &&
                  getVoucherDetails[0].explorer &&
                  !isAMEX && (
                    <li>
                      <AdvantagesList
                        advantageText={
                          languages?.productVoucherBenefitsExplorer ||
                          " Exclusive dining and accommodation discount vouchers"
                        }
                      />
                    </li>
                  )}
                {ExplorerMembership && isCampaign1363 && (
                  <li className="flex gap-4">
                    <div>
                      <AdvantageCheckIcon className="w-6 h-6" />
                    </div>
                    <p className="font-montserrat font-normal text-base text-left">
                      Cash voucher package worth VND 2,000,000 when paying with
                      a VISA Signature or VISA Infinite card. Terms and
                      Conditions apply.
                    </p>
                  </li>
                )}
                {DiscoveryMembership && getVoucherDetails[1].discovery && (
                  <li className="inclusion-list flex items-center">
                    <div className="list-icon-holder">
                      <AdvantageCheckIcon />
                    </div>
                    <span className="list-desc text-lg">
                      {languages.productVoucherBenefitsDiscovery
                        ? languages.productVoucherBenefitsDiscovery
                        : " Exclusive dining and accommodation discount vouchers"}
                    </span>
                  </li>
                )}
              </ul>
              <div>
                {/* For new CVP */}
                {refundWidgetToggle && ExplorerMembership && isQbr &&
                  <div>
                    {getBusinessExplorerContent(languages, benefitsTranslations)}
                  </div>
                }
                {refundWidgetToggle && ExplorerMembership &&
                  <div>
                    {getAllExplorerContent(languages, benefitsTranslations)}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Card> Select your membership </Card>
      )}
    </div>
  );
}
